import { useGlobalContext } from "@root/context";
import { InputSetting } from "../../../inputs/setting";
import { useModalOfferContext } from "../../context";
import { initApply } from "../../logics";
import { Interview } from "./interview";
import { Success } from "./success";

export const ApplyComponent = () => {
  const { settings } = useGlobalContext();

  const { apply, setApply, errors, disabledFields } = useModalOfferContext();

  return (
    <>
      <InputSetting
        id="status"
        label="Statut de la candidature*"
        setting={settings.ampJobStatusForApply}
        value={apply.status}
        onChange={(event) => setApply({ ...initApply, status: event.target.value })}
        error={!!errors.status}
        variant="outlined"
        disabled={disabledFields?.applyStatus}
      />
      {apply.status === "waiting_itw" && <Interview />}
      {apply.status === "success" && <Success />}
    </>
  );
};
